import { render, staticRenderFns } from "./HomeHotEventList.vue?vue&type=template&id=1008e6b1&scoped=true"
import script from "./HomeHotEventList.vue?vue&type=script&lang=js"
export * from "./HomeHotEventList.vue?vue&type=script&lang=js"
import style0 from "./HomeHotEventList.vue?vue&type=style&index=0&id=1008e6b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008e6b1",
  null
  
)

export default component.exports